import { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';
import React from 'react';
import { useIntl } from 'react-intl';

const WEBAPP_URL = process.env.NEXT_PUBLIC_WEBAPP_URL;

const ReferralPage = ({ code }: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  const i18n = useIntl();
  const router = useRouter();

  const { locale } = router;

  const trackerId = 'mywsv1v';
  const signupUrl = `${WEBAPP_URL}/signup?referral_id=${code}`;
  const redirectUrl = `https://app.adjust.com/${trackerId}?label=${code}&fallback=${signupUrl}&redirect_macos=${signupUrl}`;

  React.useEffect(() => {
    window.location.href = redirectUrl;
  }, [redirectUrl]);

  return (
    <>
      <NextSeo
        title={i18n.formatMessage({ id: 'referral.meta.title' })}
        description={i18n.formatMessage({ id: 'referral.meta.description' })}
        openGraph={{
          title: i18n.formatMessage({ id: 'referral.meta.title' }),
          description: i18n.formatMessage({ id: 'referral.meta.description' }),
          images: [
            {
              url: `/api/referral/og?code=${code}&locale=${locale}`,
              alt: i18n.formatMessage({ id: 'referral.meta.title' }),
            },
          ],
        }}
      />
      <div className="h-screen flex flex-col justify-center items-center">
        <img src="/img/logo-white.svg" alt="Finary Logo" width="120" height="32" />
      </div>
    </>
  );
};

export const getServerSideProps: GetServerSideProps<{code: string}> = async (context) => {
  return {
    props: {
      code: context.params.code?.[0],
    },
  }
}

export default ReferralPage;
